import { useState } from 'react'
import ConfirmModal from 'containers/authorised/setting/v2/components/ConfirmModal'
import ConfirmModalV2 from 'containers/authorised/NewOnboarding/components/ConfirmationModal'

import i18n from 'translations/i18n'
import { Button } from '@jisr-hr/design-system'
import { useDispatch, useSelector } from 'utils/hooks'
import {
  departmentsDelete,
  hierarchicalDepartmentsLoad,
  listDepartmentsLoad,
} from 'redux/newDepartments/actionCreators'
import { organizationInfo } from 'redux/organizationOnborading/organization/actionCreators'
import { isRtl } from 'utils/uiHelpers'
import { Typography } from '@jisr-hr/ds'
import { Department } from 'redux/newDepartments/types'

import { useDepartmentsContext } from './context'
import ContentDeleteModal from './ContentDeleteModal'

type Props = {
  confirmMessage: {
    canDelete: boolean
    message: string
    title: string
    type: string
    data?: Department
  }
  id: number
  onDone: () => void
  target?: JSX.Element
}

const DeleteDepartment = ({ id, onDone, confirmMessage, target }: Props): JSX.Element => {
  const { data } = confirmMessage
  const [isOpen, setIsOpen] = useState(false)
  const dispatch = useDispatch()
  const { isInOnboarding, setSearch, search } = useDepartmentsContext()
  const { fetching } = useSelector((s) => s.newDepartments)

  const handleDelete = (): void => {
    dispatch(departmentsDelete(id)).then(() => {
      if (isInOnboarding) {
        dispatch(organizationInfo())
      }
      setIsOpen(false)
      dispatch(hierarchicalDepartmentsLoad())
      dispatch(listDepartmentsLoad({}))
      setSearch({ ...search, deleted_id: id })
      onDone()
    })
  }

  return (
    <div>
      {target ? (
        <div onClick={(): void => setIsOpen(true)}>{target}</div>
      ) : (
        <Button
          label={i18n.t('delete')}
          size="medium"
          variant="dangerSecondary"
          onClick={(): void => setIsOpen(true)}
        />
      )}
      <ConfirmModalV2
        fetching={fetching}
        isOpen={isOpen && confirmMessage.canDelete}
        title={`${confirmMessage.title}${isRtl ? '؟' : '?'}`}
        description={
          <Typography
            text={<ContentDeleteModal data={data} />}
            style={{ margin: 24, marginBottom: 16 }}
            variant="subheading"
          />
        }
        titleConfirm="delete"
        onConfirm={handleDelete}
        onClose={(): void => setIsOpen(false)}
      />
      <ConfirmModal
        variant={confirmMessage.type}
        isOpen={isOpen && !confirmMessage.canDelete}
        hideConfirm={!confirmMessage.canDelete}
        title={confirmMessage?.title}
        message={confirmMessage.message}
        onCancel={(): void => setIsOpen(false)}
        onConfirm={handleDelete}
        labelConfirm="delete"
      />
    </div>
  )
}

export default DeleteDepartment
